import { inject } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';

export abstract class BaseApi {
  #authService: AuthService = inject(AuthService);
  protected useAuthentication = true;

  async getOptions(abortSignal?: AbortSignal) {
    const options: RequestInit = {
      ...await this.getDefaultOptions(),
      signal: abortSignal
    };
    return options;
  }

  async getDefaultOptions() {
    const headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    if (this.useAuthentication) {
      const response = await this.#authService.getToken();
      if (response) {
        const token = response.accessToken;
        headers.append('Authorization', `Bearer ${token}`);
      }
    }

    const options: RequestInit = {
      headers: headers
    };

    return options;
  }

}
